import React from "react";
import ConditionChecklist from "./condition-checklist";
import { Q8_COMORBIDITIES, ethnicityBucket } from "../../data/eligibility-rules";

// Q8 — these conditions don't reject/flag on their own; ticking any of them (other
// than "None of the above") lowers the qualifying BMI threshold. See
// src/lib/eligibility.js getBmiThreshold().
export default function Step8f({ formData, setFormData, onBack, goToStep }) {
  const bucket = ethnicityBucket(formData.ethnicity);
  const helperText =
    bucket === "white"
      ? "Selecting a condition below may lower your qualifying BMI threshold for treatment to 27 kg/m² in line with NICE guidelines."
      : "Selecting a condition below may lower your qualifying BMI threshold for treatment to 24.5 kg/m² in line with NICE guidelines.";

  return (
    <ConditionChecklist
      formData={formData}
      setFormData={setFormData}
      onBack={onBack}
      goToStep={goToStep}
      title="Have you been diagnosed with any of the following medical conditions?"
      helperText={helperText}
      options={Q8_COMORBIDITIES}
      formDataKey="q8Comorbidities"
      nextStepId="8d"
    />
  );
}
